import { render, staticRenderFns } from "./zykPlayer.vue?vue&type=template&id=2ba09d28&scoped=true"
import script from "./zykPlayer.vue?vue&type=script&lang=js"
export * from "./zykPlayer.vue?vue&type=script&lang=js"
import style0 from "./zykPlayer.vue?vue&type=style&index=0&id=2ba09d28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba09d28",
  null
  
)

export default component.exports